'use client';

import { faTrashCan } from '@fortawesome/pro-light-svg-icons';
import { DataTestIdEnum } from '@medprev-web-app/datatestid';

import { Button } from '@/components/ui/button/button.component';

interface CartItemRemoveButtonProps {
  onRemove: () => void;
}

export function CartItemRemoveButton({ onRemove }: CartItemRemoveButtonProps) {
  return (
    <Button
      variant="text"
      startIcon={faTrashCan}
      startIconSize="1x"
      className="h-10 w-full text-base text-green-500"
      onClick={onRemove}
      data-testid={DataTestIdEnum.CART_ITEM_REMOVE_BUTTON}
    >
      Remover
    </Button>
  );
}
